import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";

export const getHorarioBySalon = async (salonId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.get(`${API_BASE_URL}/salones/${salonId}/horario`, { headers });
  return response.data.data;
};

export const uploadHorario = async (data) => {
    const token = localStorage.getItem("authToken");
    const headers = { Authorization: `${token}` };
  
    const response = await axios.post(`${API_BASE_URL}/salones`, data, { headers });
    return response.data;
  };
